module.exports = __webpack_public_path__ + "img/joinus-title.22a5aaf0.png";